import { render, staticRenderFns } from "./index.vue?vue&type=template&id=039a6bc7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=039a6bc7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a6bc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('039a6bc7')) {
      api.createRecord('039a6bc7', component.options)
    } else {
      api.reload('039a6bc7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=039a6bc7&scoped=true", function () {
      api.rerender('039a6bc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/user/index.vue"
export default component.exports